const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAgroIconBrown1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 46.56 56.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "27.52 35.28 21.17 45.86 27.52 56.44 40.21 56.44 46.56 45.86 40.21 35.28 27.52 35.28",
    style: {
      fill: "#a26128"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "25.4 34.1 19.05 23.52 6.35 23.52 0 34.1 6.35 44.68 19.05 44.68 25.4 34.1",
    style: {
      fill: "#a26128"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "27.52 11.76 21.17 22.34 27.52 32.92 40.22 32.92 46.56 22.34 40.22 11.76 27.52 11.76",
    style: {
      fill: "#a26128"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "19.05 21.16 25.4 10.58 19.05 0 6.35 0 0 10.58 6.35 21.16 19.05 21.16",
    style: {
      fill: "#a26128"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgroIconBrown1);
export default __webpack_public_path__ + "static/media/agro-icon-brown-1.82d53f36eba7f7ec8ddb2899065db888.svg";
export { ForwardRef as ReactComponent };